'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var PopupManagerContext = require('./PopupManagerContext.js');

var PopupManager = function (_a) {
    var children = _a.children;
    var _b = react.useState(null), currentPopupCallback = _b[0], setCurrentPopupCallback = _b[1];
    var unregister = react.useCallback(function () {
        setCurrentPopupCallback(null);
    }, []);
    var closeCurrent = react.useCallback(function () {
        if (currentPopupCallback) {
            currentPopupCallback();
            unregister();
        }
    }, [currentPopupCallback, unregister]);
    var register = react.useCallback(function (popupCloseCallback) {
        setCurrentPopupCallback(function () { return popupCloseCallback; });
    }, []);
    var context = react.useMemo(function () { return ({
        closeCurrent: closeCurrent,
        register: register,
        unregister: unregister
    }); }, [closeCurrent, register, unregister]);
    return (jsxRuntime.jsx(PopupManagerContext.default.Provider, tslib.__assign({ value: context }, { children: jsxRuntime.jsx(jsxRuntime.Fragment, { children: children }) })));
};
var PopupManager$1 = PopupManager;

exports.default = PopupManager$1;
//# sourceMappingURL=PopupManager.js.map
